module.exports = __webpack_public_path__ + "static/media/main_logo.760cce54.svg";